var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 38,
    viewBox: "0 0 28 38",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.91806 9.33772H4.4527H0V31.4707C0 34.7844 2.68629 37.4707 6 37.4707H13.94H21.88C25.1937 37.4707 27.88 34.7844 27.88 31.4707V6.5293C27.88 3.21559 25.1937 0.529297 21.88 0.529297H8.90541L8.91806 9.33772ZM17.6801 14.3975C18.5092 14.3975 19.1812 15.0695 19.1812 15.8986C19.1812 16.7276 18.5092 17.3997 17.6801 17.3997C16.8511 17.3997 16.179 16.7276 16.179 15.8986C16.1883 15.0761 16.8577 14.4143 17.6801 14.4143V14.3975ZM19.4553 26.4275L20.7203 25.6474H20.754C19.3924 23.4041 16.9585 22.0342 14.3343 22.0342C11.71 22.0342 9.27614 23.4041 7.91452 25.6474L9.17949 26.4275C10.2686 24.6313 12.2168 23.5343 14.3174 23.5343C16.418 23.5343 18.3661 24.6313 19.4553 26.4275ZM10.921 14.4143C11.75 14.4143 12.4221 15.0864 12.4221 15.9154C12.4221 16.7445 11.75 17.4165 10.921 17.4165C10.0919 17.4165 9.41987 16.7445 9.41987 15.9154C9.41987 15.5173 9.57802 15.1355 9.85953 14.854C10.141 14.5725 10.5229 14.4143 10.921 14.4143ZM7.23158 7.65082H1.72473L7.23158 2.14397V7.65082Z",
    fill: "#65707B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileError);
export default ForwardRef;